import { createSelector } from 'reselect';

const selectSystemInformations = (state: any) => state.systemInformations;


export const selectSystemInformationsCurrentItem = createSelector([selectSystemInformations], (systemInformations) => systemInformations.current);

export const selectSystemInformationsListItems = createSelector([selectSystemInformations], (systemInformations) => systemInformations.list);

export const selectSystemInformationsItemById = (itemId: any) =>
    createSelector(selectSystemInformationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSystemInformationsCreatedItem = createSelector([selectSystemInformations], (systemInformations) => systemInformations.create);

export const selectSystemInformationsUpdatedItem = createSelector([selectSystemInformations], (systemInformations) => systemInformations.update);

export const selectSystemInformationsReadItem = createSelector([selectSystemInformations], (systemInformations) => systemInformations.read);

export const selectSystemInformationsDeletedItem = createSelector([selectSystemInformations], (systemInformations) => systemInformations.delete);

export const selectSystemInformationsearchedItems = createSelector([selectSystemInformations], (systemInformations) => systemInformations.search);

export const selectSystemInformationsItemsCount = createSelector([selectSystemInformations], (systemInformations) => systemInformations.count);

export const selectSystemInformationsItemsFilter = createSelector([selectSystemInformations], (systemInformations) => systemInformations.filter);